import { render } from "./PageHeader.vue?vue&type=template&id=0adfc80a&scoped=true&ts=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=0adfc80a&lang=scss&scoped=true"

import exportComponent from "/Users/wangkaining/Code/vue_code/newapps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adfc80a"]])

export default __exports__